import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import SelectAutocomplete from "common/SelectAutocomplete";
import ActionsContext from "common/ActionsContext";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
  width: 300px;

  .type-title {
    font-size: 14px;
    font-family: "AllianceNo2-SemiBold";
    color: var(--subtitle-color);
    margin-right: 10px;
    font-weight: normal;
  }
`;

const WrapperEditMode = styled.div`
  width: 100%;
  display: flex;

  .type-selector {
    width: 150px;
  }
`;

const getSubscriberGroupTypes = (ifCl) => {
  return ifCl.run("show api subscriber-group types").then((response) => {
    const types = response.trim(/\s/).split("\n");
    return types;
  });
};

const getSubscriberGroupTypeMap = (ifCl) => {
  return ifCl.run("show api subscriber-group").then((response) => {
    const [header, ...rows] = response.trim(/\s/).split("\n");
    const headerAttrs = header.split(/\s+/);
    const subscriberNameId = headerAttrs.findIndex(
      (el) => el === "SUBSCRIBER-GROUP"
    );
    const subscriberTypeId = headerAttrs.findIndex((el) => el === "GROUP-TYPE");
    return rows.reduce((acc, row) => {
      const rowAttrs = row.split(/\s+/);
      acc[rowAttrs[subscriberNameId]] = rowAttrs[subscriberTypeId];
      return acc;
    }, {});
  });
};

const Type = ({ nameGroup }) => {
  const actions = useContext(ActionsContext);
  const [editMode, setEditMode] = useState(false);
  const [typeSelected, setTypeSelected] = useState();
  const [types, setTypes] = useState([]);
  const options = Array.from(new Set(types)).sort().reduce((acc, type) => {
    if (type !== "all-subscribers") {
      acc.push({ label: type, value: type });
    }
    return acc;
  }, []);

  const doLoad = () => {
    Promise.all([getSubscriberGroupTypes(ifCl), getSubscriberGroupTypeMap(ifCl)]).then(([types, groupTypes]) => {
      setTypeSelected(groupTypes[nameGroup] || "generic")
      setTypes(types)
    });
  };

  useEffect(() => {
    doLoad();
  }, []);

  const handleOk = () => {
    ifCl
      .run(`api subscriber-group ${nameGroup} type ${typeSelected}`)
      .then((response) => {
        if(response ===""){
          actions.send("subscriber-group-type-changed", {
            type: typeSelected,
            name: nameGroup,
          })
          setEditMode(false);
        } else {
          throw "The group type change failed."
        }    
      })
      .catch((error) => showModalError("Error", error));
  };

  return (
    <Wrapper>
      <div className="type-title">Type:</div>
      {!editMode ? (
        <>
          <div>{typeSelected}</div>
          {nameGroup !== "all-subscribers" ? (
            <button
              type="button"
              className="btn btn-default waves-effect shadow-none"
              onClick={() => setEditMode(true)}
            >
              <i className="material-icons">edit</i>
            </button>
          ) : null}
        </>
      ) : null}
      {editMode && typeSelected ? (
        <WrapperEditMode>
          <SelectAutocomplete
            title="Manage Type"
            name="Subscriber Group Type"
            className="type-selector"
            selected={typeSelected}
            onChange={(value) => setTypeSelected(value)}
            options={options}
          />
          <button
            type="button"
            className="btn btn-default waves-effect shadow-none"
            onClick={() => handleOk()}
          >
            OK
          </button>
        </WrapperEditMode>
      ) : null}
    </Wrapper>
  );
};

export default Type;
